import { ArrowDownRight, Gauge, ShoppingBag } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const INFLATOR =
  "https://images.pexels.com/photos/3807450/pexels-photo-3807450.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const VOUCHER =
  "https://images.unsplash.com/photo-1649734926695-1b1664e98842?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxhbWF6b24lMjBnaWZ0JTIwY2FyZCUyMHZvdWNoZXJ8ZW58MHx8fHwxNzg3MDM4NTc4fDA&ixlib=rb-4.1.0&q=85";

export default function OfferGrid() {
  return (
    <section id="offer" data-testid="offer-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <Chapter number="02" title="Choose Your Reward" />
          <h2 className="font-display text-4xl uppercase tracking-tight text-white sm:text-5xl">
            One purchase. <span className="text-[#FF3B30]">Two rewards.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-12 gap-4">
          <Reveal className="col-span-12 lg:col-span-7" delay={0.1}>
            <div
              data-testid="offer-card-inflator"
              className="group relative h-[420px] overflow-hidden border border-white/10"
            >
              <img
                src={INFLATOR}
                alt="Mechanic inflating a car tyre"
                className="h-full w-full object-cover grayscale transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" aria-hidden />
              <div className="absolute bottom-0 left-0 p-8 md:p-10">
                <p className="mb-3 flex items-center gap-2 font-heading text-xs font-bold uppercase tracking-[0.3em] text-[#FFCC00]">
                  <Gauge className="h-4 w-4" aria-hidden /> Reward 01
                </p>
                <h3 className="font-display text-3xl uppercase text-white sm:text-4xl">
                  Free Tyre Inflator
                </h3>
                <p className="mt-3 max-w-md text-sm text-white/70 md:text-base">
                  Portable digital inflator worth ₹4,000 — yours free with every set of 4 car tyres.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal className="col-span-12 lg:col-span-5" delay={0.2}>
            <div
              data-testid="offer-card-voucher"
              className="group relative h-[420px] overflow-hidden border border-white/10"
            >
              <img
                src={VOUCHER}
                alt="Amazon shopping voucher"
                className="h-full w-full object-cover grayscale transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/10" aria-hidden />
              <div className="absolute bottom-0 left-0 p-8 md:p-10">
                <p className="mb-3 flex items-center gap-2 font-heading text-xs font-bold uppercase tracking-[0.3em] text-[#FF3B30]">
                  <ShoppingBag className="h-4 w-4" aria-hidden /> Reward 02
                </p>
                <h3 className="font-display text-3xl uppercase text-white sm:text-4xl">
                  ₹2,000 Amazon Voucher
                </h3>
                <p className="mt-3 text-sm text-white/70 md:text-base">
                  Prefer shopping credit? Take an Amazon voucher instead.
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.3}>
          <div className="mt-4 flex items-center justify-between border border-white/10 bg-[#0a0a0a] px-8 py-6">
            <p className="text-sm text-white/60 md:text-base">
              Buy any 4 car tyres from 10 premium brands — pick your reward when you visit the store.
            </p>
            <ArrowDownRight className="h-6 w-6 shrink-0 text-[#FF3B30]" aria-hidden />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
